import Ref from "csi/heading/Ref";
import html from "csi/html";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import { create3DRotationIcon } from "./utility/ThreeDRotationIcon";

const ThreeDViewableDocumentRenderer = declare(Ref, {
	toHtmlStatic(ctx, h, refNode, actionData) {
		const { view, bExcel, bPopup, bPrint } = ctx;
		const url = this._getValue(ctx, h);

		if (xml.isValidURL(url) && !bPopup && !bExcel && !bPrint) {
			refNode = html.create("div", {
				class: "csi-flex-row",
			}, refNode);
    
			this.inherited(arguments);    
			return create3DRotationIcon(view, refNode, url, h, null);
		} else {
			return this.inherited(arguments);
		}
	}, 
});

export = ThreeDViewableDocumentRenderer;
